/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRainyIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-rainy"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M14.1 22.2Q13.6 22.45 13.07 22.27Q12.55 22.1 12.3 21.6L10.8 18.6Q10.55 18.1 10.72 17.57Q10.9 17.05 11.4 16.8Q11.9 16.55 12.43 16.73Q12.95 16.9 13.2 17.4L14.7 20.4Q14.95 20.9 14.78 21.43Q14.6 21.95 14.1 22.2ZM20.1 22.2Q19.6 22.45 19.07 22.27Q18.55 22.1 18.3 21.6L16.8 18.6Q16.55 18.1 16.73 17.57Q16.9 17.05 17.4 16.8Q17.9 16.55 18.43 16.73Q18.95 16.9 19.2 17.4L20.7 20.4Q20.95 20.9 20.77 21.43Q20.6 21.95 20.1 22.2ZM8.1 22.2Q7.6 22.45 7.08 22.27Q6.55 22.1 6.3 21.6L4.8 18.6Q4.55 18.1 4.72 17.57Q4.9 17.05 5.4 16.8Q5.9 16.55 6.42 16.73Q6.95 16.9 7.2 17.4L8.7 20.4Q8.95 20.9 8.78 21.43Q8.6 21.95 8.1 22.2ZM7.5 16.07Q5.08 16.07 3.38 14.38Q1.68 12.68 1.68 10.25Q1.68 8.1 3.09 6.47Q4.5 4.85 6.58 4.5Q7.42 3.05 8.85 2.24Q10.28 1.43 12 1.43Q14.28 1.43 16 2.89Q17.73 4.35 18.2 6.47Q19.95 6.72 21.14 8.06Q22.32 9.4 22.32 11.25Q22.32 13.25 20.91 14.66Q19.5 16.07 17.5 16.07Z" fill={color} />
    </svg>
  );
}
